import { Poly } from "../../engine/Poly";
import {
  DEFAULT_OUTPUT_ENCODING,
  DEFAULT_SHADOW_MAP_TYPE,
  DEFAULT_TONE_MAPPING
} from "../../engine/nodes/rop/WebGLRenderer";
import { defaultPixelRatio } from "./defaultPixelRatio";
import { CoreObject } from "../geometry/Object";
import { CameraAttribute } from "./CoreCamera";
import { CoreType } from "../Type";
import { RopType } from "../../engine/poly/registers/nodes/types/Rop";
import { NodeContext } from "../../engine/poly/NodeContext";
const _CoreCameraRendererController = class {
  static renderer(canvas) {
    return this._renderersByCanvas.get(canvas);
  }
  static createRenderer(options) {
    const { camera, canvas, scene } = options;
    const gl = Poly.renderersController.getRenderingContext(canvas);
    if (!gl) {
      console.error("failed to create webgl context");
      return;
    }
    let renderer;
    const rendererROPPath = CoreObject.attribValue(camera, CameraAttribute.RENDERER_PATH);
    if (rendererROPPath && CoreType.isString(rendererROPPath)) {
      const rendererROP = scene.node(rendererROPPath);
      if (rendererROP && rendererROP.type() == RopType.WEBGL && rendererROP.context() == NodeContext.ROP) {
        renderer = rendererROP.createRenderer(camera, canvas, gl);
      }
    }
    if (!renderer) {
      renderer = this._defaultRendererByContext.get(gl);
      if (!renderer) {
        renderer = _CoreCameraRendererController.createDefaultRenderer(canvas, gl);
        this._defaultRendererByContext.set(gl, renderer);
      }
    }
    scene.renderersRegister.registerRenderer(renderer);
    this._renderersByCanvas.set(canvas, renderer);
    return renderer;
  }
  static setRendererSize(canvas, size) {
    const renderer = this.renderer(canvas);
    if (renderer) {
      const updateStyle = false;
      renderer.setSize(size.x, size.y, updateStyle);
    }
  }
  static createDefaultRenderer(canvas, gl) {
    const params = {
      canvas,
      antialias: false,
      context: gl
    };
    const renderer = Poly.renderersController.createWebGLRenderer(params);
    const pixelRatio = defaultPixelRatio();
    renderer.setPixelRatio(pixelRatio);
    renderer.shadowMap.enabled = true;
    renderer.shadowMap.type = DEFAULT_SHADOW_MAP_TYPE;
    renderer.physicallyCorrectLights = true;
    renderer.toneMapping = DEFAULT_TONE_MAPPING;
    renderer.toneMappingExposure = 1;
    renderer.outputEncoding = DEFAULT_OUTPUT_ENCODING;
    if (Poly.renderersController.printDebug()) {
      Poly.renderersController.printDebugMessage("create default renderer");
      Poly.renderersController.printDebugMessage({
        params,
        pixelRatio
      });
    }
    return renderer;
  }
};
export let CoreCameraRendererController = _CoreCameraRendererController;
CoreCameraRendererController._defaultRendererByContext = /* @__PURE__ */ new Map();
CoreCameraRendererController._renderersByCanvas = /* @__PURE__ */ new Map();
